import { render, staticRenderFns } from "./ProdutoForm.vue?vue&type=template&id=b9f96ee8"
import script from "./ProdutoForm.vue?vue&type=script&lang=js"
export * from "./ProdutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports